<script>
  import {beforeUpdate, onDestroy, onMount} from "svelte";
  import {store} from "./Utils/stores";
  import VideoYTElement from "./VideoYTElement.svelte";
  import {localVideoLink, openLink} from "./services/localServices";
  import {isOffline} from "./services/configService";
  import VideoLocalElement from "./VideoLocalElement.svelte";
  import ShareThisVideoView from "./ShareThisVideoView.svelte";

  export let video
  export let title
  let video_component = null;
  let update_source = true;
  let local_video = true;

  function vtutorial_link(avideo) {
    if (avideo && avideo.slug.current) {
      return `https://storage.vectric.com/tutorials/v12.5/${avideo.slug.current}.vtutorial`;
    } else {
      return "";
    }
  }

  function installLink(avideo) {
    if (avideo && avideo.slug.current) {
      return `vectric://install?tutorial=${vtutorial_link(avideo)}`;
    }
    return "";
  }

  function downloadLink(avideo) {
    return vtutorial_link(avideo);
  }

  function isLocalVideoFound(video) {
    // Update the video source
    // Check for local file existence by loading and throwing an error
    // if an error occurs then we will go back to Youtube
    local_video = false;
    if (isOffline()) {
      let v = document.createElement('VIDEO');
      v.addEventListener('error', function (e) {
        local_video = false;
      });
      v.addEventListener('loadeddata', function () {
        local_video = true;
      });
      v.src = localVideoLink(video);
    } else {
      local_video = false;
    }
  }

  function update_video_source() {
    // Update the video source
    // Check for local file existence by loading and throwing an error
    // if an error occurs then we will go back to Youtube
    local_video = false;
    if (isOffline()) {
      let v = document.createElement('VIDEO');
      v.addEventListener('error', function (e) {
        local_video = false;
      });
      v.addEventListener('loadeddata', function () {
        local_video = true;
      });
      v.src = localVideoLink(video);
    } else {
      local_video = false;
    }
  }


  function get_open_link(avideo) {
    return openLink(avideo);
  }

  function get_time_percentage(avideo, bookmark) {
    if (avideo.videoDuration !== undefined) {
      let thetime = bookmark.bookmarkTime.minutes * 60;
      let thetotaltime = thetime + bookmark.bookmarkTime.seconds;

      let videotime = avideo.videoDuration.minutes * 60;
      let totalvideotime = videotime + avideo.videoDuration.seconds;

      return (thetotaltime * 100) / totalvideotime;
    }
  }

  function get_component(local) {
    if (local) {
      return VideoLocalElement;
    } else {
      console.log("Video component is YT")
      return VideoYTElement;
    }
  }


  function set_player_time(avideo, bookmark) {
    let thetime = bookmark.bookmarkTime.minutes * 60;
    let thetotaltime = thetime + bookmark.bookmarkTime.seconds;
    video_component.set_player_time(thetotaltime);
  }


  beforeUpdate(() => {
    if (update_source) {
      update_source = false;
      update_video_source();
    }
  })

  onDestroy(store.subscribe(value => {
    local_video = false;
    update_source = true;
  }));

  $: {
    isLocalVideoFound(video)
  }

  let bookmarksState = false

  function toggle_bookmarks() {
    if(window.innerWidth < 768) {
      bookmarksState = !bookmarksState
    }
  }
  function backtoVideo() {
    let section = document.getElementById('modalBody');
    section.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

</script>

<div>
  <!-- Description -->
  <div class="vec-flex vec-justify-center">
    {#if video.youtube}
      <div id="videoTop" class="vec-w-full vec-h-full vec-aspect-[16/9]">
          {#key video.youtube}
            <svelte:component bind:this={video_component}
              this={get_component(local_video)}
              video={video}
              on:video-ended on:soft-video-end
            />
          {/key}
      </div>
    {:else}
      <div class=" col-12 py-5 mt-2  bg-light">
        <h4 class="vec-text-center my-5 py-5">Video could not be found</h4>
      </div>
    {/if}
  </div>

  <!-- Actions -->
  <div class="vec-bg-lighterGrey vec-w-full vec-items-center vec-p-3 vec-rounded-b-md vec-hidden lg:vec-grid lg:vec-grid-cols-3">
    <div class="vec-flex vec-justify-self-start vec-space-x-5 vec-uppercase vec-text-sm vec-items-center vec-text-black vec-col-span-2">
      <p class="vec-text-darkGrey">Project Files</p>
    {#if local_video}
      <p><a target="_parent" href={get_open_link(video)} class="vec-text-black vec-flex vec-items-center hover:vec-opacity-50">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" class="vec-mr-2">
            <path d="M0,0V21H21V13H20v7H1V1H8V0ZM11,0V1h8.294L7.833,12.46l.707.707L20,1.706V10h1V0Z"/>
          </svg>
          Open</a></p>
    {/if}
    {#if !local_video}
      <p><a target="_parent" href={installLink(video)} class="vec-text-black vec-flex vec-items-center hover:vec-opacity-50">
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="21" viewBox="0 0 27 21" class="vec-mr-2">
          <path d="M2,19H7V18H2Zm0-2H7V16H2Zm0-2H7V14H2Zm20-1.5V16H13V13.5H12V17H23V13.5ZM2,13H5V12H2Zm0-2H7V10H2ZM2,9H7V8H2ZM2,7H7V6H2ZM17,6v6.792l-2.146-2.146-.708.707L17.5,14.706l3.354-3.353-.708-.707L18,12.792V6ZM2,5H5V4H2ZM1,3H8V20H1ZM9,3H26V20H9ZM1,1H26V2H1ZM0,21H27V0H0Z" transform="translate(0 0.001)"/>
        </svg>              
        Install</a></p>
      <p><a target="_parent" href={downloadLink(video)} class="vec-text-black vec-flex vec-items-center hover:vec-opacity-50">
        <svg xmlns="http://www.w3.org/2000/svg" width="20.999" height="20" viewBox="0 0 20.999 20" class="vec-mr-2">
          <path d="M20,13.5V19H1V13.5H0V20H21V13.5ZM10,0V14.792L4.851,9.646l-.708.708L10.5,16.707l6.355-6.353-.708-.708L11,14.792V0Z"/>
        </svg>
        Download</a></p>
    {/if}
    </div>
    <ShareThisVideoView video={video}/>
  </div>
    <div class="vec-w-full vec-flex vec-my-4 sm:vec-items-center vec-flex-col sm:vec-flex-row">
      <h3 class="vec-text-lg vec-flex-grow">
        {title}
      </h3>
    </div>
    <div class="vec-py-2 vec-text-sm">
      {@html video.longDescription}
    </div>

  {#if video.bookmarks && video.bookmarks.length > 0}
  
    <div id="bookmarks" class:open-bookmarks={bookmarksState} class="vec-flex md:vec-mt-8 vec-absolute md:vec-relative vec-top-0 vec-bg-white vec-h-full vec-shadow-lg md:vec-shadow-none vec-rounded-r-xl md:vec-rounded-none">
      <div id="bookmarksTab" class="cursor-pointer md:vec-hidden vec-absolute vec-left-[100%] vec-top-[110px] vec-z-1 vec-px-3 vec-py-1 vec-bg-white vec-shadow-lg vec-origin-bottom-left vec-rotate-90 vec-text-nowrap vec-text-right vec-rounded-t vec-text-xs" on:click={() => {
        toggle_bookmarks();
      }}>
      {#if bookmarksState}Hide{:else}View{/if}&nbsp;Bookmarks</div>
      <div class="vec-bookmarks-content vec-w-full vec-h-full vec-overflow-y-auto md:vec-overflow-visible vec-p-5 md:vec-p-0 vec-relative vec-z-2 vec-bg-white vec-rounded-r-xl md:vec-rounded-none">
        <h4 class="vec-mb-2">Bookmarks</h4>
        {#if video.videoDuration}
        <div class=" vec-hidden md:vec-block vec-bg-white vec-rounded-md vec-p-5" style="box-shadow:0 1px 20px rgba(0,0,0,0.15)">
          <div class="vec-relative vec-w-full vec-h-5 vec-border vec-border-t-0 vec-border-b-0 vec-border-black">
              <div class="vec-w-full vec-h-[4px] vec-bg-midGrey vec-absolute vec-left-0 vec-top-[8px]"></div>
              {#each video.bookmarks as bookmark,i}
                <div on:click|preventDefault={set_player_time(video, bookmark),backtoVideo} class="vec-box-content vec-border-l-2 vec-border-white vec-absolute vec-flex vec-w-[14px] vec-h-[18px] vec-top-[1px] vec-cursor-pointer" style="left:calc({get_time_percentage(video, bookmark)}% - 10px)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" class="vec-absolute vec-top-0 vec-left-0">
                    <path d="M0,0H14V18L7,15,0,18Z" />
                  </svg>                  
                  <div class="vec-h-[18px] vec-text-center vec-w-full vec-relative vec-text-white vec-leading-4 vec-text-[0.625rem]">{i + 1}</div>
                </div>
              {/each}
          </div>
        </div>
        <ol class="bookmark-list vec-mt-3 md:vec-px-5 vec-list-style-none vec-text-sm">
          {#each video.bookmarks as bookmark,i}
            <li class="vec-relative vec-flex vec-pl-6 vec-py-3 md:vec-py-2 vec-opacity-100 md:vec-opacity-60 hover:vec-opacity-100 vec-cursor-pointer" on:click={set_player_time(video, bookmark),toggle_bookmarks(),backtoVideo}>
              <div class="vec-absolute vec-flex vec-w-[14px] vec-h-[18px] vec-top-3 md:vec-top-2 vec-left-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" class="vec-absolute vec-top-0 vec-left-0 fill-midGrey">
                  <path d="M0,0H14V18L7,15,0,18Z" />
                </svg>                
                <div class="vec-h-[18px] vec-text-center vec-w-full vec-relative vec-text-white vec-leading-4 vec-text-[0.625rem]">{i + 1}</div>
              </div>
              {bookmark.bookmarkName}
            </li>
          {/each}
        </ol>
        {/if}
        
      </div>
    </div>
  {/if}

</div>

<style>
    .bookmark-list {
        columns: 1;
    }
    @media only screen and (min-width: 768px) {
      .bookmark-list {
        columns: 2;
      }
    }
    @media only screen and (max-width: 767px) {
    #bookmarks {
      right:100%;
      width:80%;
      transition: right 0.3s ease-out;
    }

    #bookmarks.open-bookmarks {
      right:20%;
      z-index:2;
    }

    #bookmarksTab {
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    }
  }


</style>

